export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  status: '连载中' | '已完结';
  rating: number;
  description: string;
  updateTime: string;
  views: number;
  tags: string[];
  chapters: Chapter[];
}

export interface Chapter {
  id: string;
  title: string;
  updateTime: string;
  pageCount: number;
}

export interface Category {
  id: string;
  name: string;
  slug: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { id: 'cat-1', name: '热血', slug: 'rexue', icon: 'ri-fire-line', count: 128 },
  { id: 'cat-2', name: '恋爱', slug: 'lianai', icon: 'ri-heart-line', count: 96 },
  { id: 'cat-3', name: '玄幻', slug: 'xuanhuan', icon: 'ri-magic-line', count: 85 },
  { id: 'cat-4', name: '悬疑', slug: 'xuanyi', icon: 'ri-search-eye-line', count: 64 },
  { id: 'cat-5', name: '搞笑', slug: 'gaoxiao', icon: 'ri-emotion-laugh-line', count: 72 },
  { id: 'cat-6', name: '科幻', slug: 'kehuan', icon: 'ri-rocket-line', count: 53 },
  { id: 'cat-7', name: '都市', slug: 'dushi', icon: 'ri-building-line', count: 78 },
  { id: 'cat-8', name: '古风', slug: 'gufeng', icon: 'ri-landscape-line', count: 45 },
  { id: 'cat-9', name: '冒险', slug: 'maoxian', icon: 'ri-compass-line', count: 67 },
  { id: 'cat-10', name: '奇幻', slug: 'qihuan', icon: 'ri-moon-line', count: 59 },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '斗破苍穹',
    author: '天蚕土豆',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20young%20warrior%20with%20flaming%20fist%20in%20martial%20arts%20fantasy%20setting%2C%20dynamic%20action%20pose%2C%20traditional%20Chinese%20clothing%2C%20dramatic%20lighting%2C%20manga%20cover%20art%20quality%2C%20clean%20background%20with%20flame%20effects&width=400&height=560&seq=manga-doupo-cangqiong&orientation=portrait',
    category: '热血',
    categorySlug: 'rexue',
    status: '连载中',
    rating: 9.5,
    description: '萧炎，曾是天才少年，却在一夜之间失去所有修为，沦为废柴。在遭受无数嘲讽与冷眼后，他凭借一枚神秘戒指和坚韧不拔的意志，重新踏上修炼之路，誓要站在大陆之巅！',
    updateTime: '2026-08-05',
    views: 1520000,
    tags: ['热血', '玄幻', '战斗', '成长'],
    chapters: [
      { id: 'ch-1-1', title: '第1话 陨落的天才', updateTime: '2024-01-15', pageCount: 42 },
      { id: 'ch-1-2', title: '第2话 神秘戒指', updateTime: '2024-01-22', pageCount: 38 },
      { id: 'ch-1-3', title: '第3话 重新修炼', updateTime: '2024-02-01', pageCount: 45 },
      { id: 'ch-1-4', title: '第4话 初次试炼', updateTime: '2024-02-10', pageCount: 40 },
      { id: 'ch-1-5', title: '第5话 魔兽山脉', updateTime: '2024-02-20', pageCount: 43 },
    ],
  },
  {
    id: 'comic-2',
    title: '天官赐福',
    author: '墨香铜臭',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20elegant%20immortal%20in%20flowing%20white%20robes%20with%20flower%20petals%2C%20ethereal%20atmosphere%2C%20traditional%20Chinese%20aesthetic%2C%20soft%20dreamy%20lighting%2C%20romantic%20fantasy%20manga%20cover%20art&width=400&height=560&seq=manga-tianguancifu&orientation=portrait',
    category: '古风',
    categorySlug: 'gufeng',
    status: '连载中',
    rating: 9.8,
    description: '八百年前，谢怜曾是仙乐国的太子殿下，受万民敬仰。一朝国破，他从云端跌落，成为无人问津的破烂仙人。在漫长的岁月中，他遇见了花城——那个为他等待了八百年的红衣少年。',
    updateTime: '2026-08-04',
    views: 2100000,
    tags: ['古风', '仙侠', '恋爱', '玄幻'],
    chapters: [
      { id: 'ch-2-1', title: '第1话 太子殿下', updateTime: '2023-06-01', pageCount: 40 },
      { id: 'ch-2-2', title: '第2话 红衣少年', updateTime: '2023-06-08', pageCount: 42 },
      { id: 'ch-2-3', title: '第3话 八百年的等待', updateTime: '2023-06-15', pageCount: 38 },
    ],
  },
  {
    id: 'comic-3',
    title: '一人之下',
    author: '米二',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20modern%20supernatural%20manhua%20style%20young%20man%20with%20mysterious%20energy%20powers%20in%20urban%20setting%2C%20dynamic%20martial%20arts%20pose%2C%20cool%20expression%2C%20manga%20cover%20art%20with%20clean%20dark%20background&width=400&height=560&seq=manga-yirenzhixia&orientation=portrait',
    category: '玄幻',
    categorySlug: 'xuanhuan',
    status: '连载中',
    rating: 9.6,
    description: '大学生张楚岚在爷爷去世后，平静的生活被一个神秘少女打破。为了解开爷爷和自身的秘密，他踏入了异人世界。在这里，他结识了一群志同道合的伙伴，共同面对种种挑战。',
    updateTime: '2026-08-05',
    views: 1850000,
    tags: ['玄幻', '都市', '异能', '冒险'],
    chapters: [
      { id: 'ch-3-1', title: '第1话 异人', updateTime: '2022-03-10', pageCount: 36 },
      { id: 'ch-3-2', title: '第2话 宝儿姐', updateTime: '2022-03-17', pageCount: 40 },
      { id: 'ch-3-3', title: '第3话 天下会', updateTime: '2022-03-24', pageCount: 38 },
    ],
  },
  {
    id: 'comic-4',
    title: '狐妖小红娘',
    author: '小新',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20romantic%20fantasy%20manhua%20style%20beautiful%20fox%20spirit%20girl%20with%20red%20hair%20and%20traditional%20dress%2C%20cherry%20blossom%20petals%2C%20dreamy%20warm%20atmosphere%2C%20romantic%20manga%20cover%20art&width=400&height=560&seq=manga-huyaoxiaohongniang&orientation=portrait',
    category: '恋爱',
    categorySlug: 'lianai',
    status: '已完结',
    rating: 9.7,
    description: '在人妖共存的世界上，狐妖一族专门为前世恋人牵线搭桥。涂山苏苏是狐妖一族的小红娘，她和道士白月初一起，帮助一对对前世恋人再续前缘，也在过程中收获了自己的爱情。',
    updateTime: '2026-07-20',
    views: 2300000,
    tags: ['恋爱', '奇幻', '古风', '治愈'],
    chapters: [
      { id: 'ch-4-1', title: '第1话 小红娘', updateTime: '2021-01-05', pageCount: 35 },
      { id: 'ch-4-2', title: '第2话 前世今生', updateTime: '2021-01-12', pageCount: 40 },
    ],
  },
  {
    id: 'comic-5',
    title: '全职高手',
    author: '蝴蝶蓝',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20esports%20manhua%20style%20cool%20gamer%20with%20headphones%20holding%20glowing%20keyboard%2C%20cyberpunk%20aesthetic%2C%20dynamic%20gaming%20theme%2C%20manga%20cover%20art%20with%20dark%20blue%20tech%20background&width=400&height=560&seq=manga-quanzhigaoshou&orientation=portrait',
    category: '热血',
    categorySlug: 'rexue',
    status: '已完结',
    rating: 9.6,
    description: '网游荣耀中被誉为教科书级别的顶尖高手叶修，因为种种原因遭到俱乐部的驱逐。离开职业圈的他栖身于一家网吧成了一个小小的网管。但是，拥有十年游戏经验的他，在荣耀新开的第十区重新投入了游戏，带着对往昔的回忆，和一把未完成的自制武器，开始了重返巅峰之路。',
    updateTime: '2026-07-15',
    views: 1980000,
    tags: ['热血', '电竞', '竞技', '成长'],
    chapters: [
      { id: 'ch-5-1', title: '第1话 被驱逐的高手', updateTime: '2020-05-10', pageCount: 38 },
      { id: 'ch-5-2', title: '第2话 第十区', updateTime: '2020-05-17', pageCount: 42 },
    ],
  },
  {
    id: 'comic-6',
    title: '魔道祖师',
    author: '墨香铜臭',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20manhua%20style%20dark%20robed%20cultivator%20with%20flute%20and%20sword%2C%20mysterious%20ancient%20Chinese%20setting%2C%20dramatic%20moonlight%2C%20dark%20fantasy%20manga%20cover%20art&width=400&height=560&seq=manga-modaozushi&orientation=portrait',
    category: '玄幻',
    categorySlug: 'xuanhuan',
    status: '已完结',
    rating: 9.9,
    description: '夷陵老祖魏无羡死后十三年，被莫玄羽用禁术强行献舍复活。重生归来的他不得不接受这个事实，与故人蓝忘机再次相遇，一同揭开十三年前的惊天秘密。',
    updateTime: '2026-06-30',
    views: 2800000,
    tags: ['玄幻', '仙侠', '悬疑', '古风'],
    chapters: [
      { id: 'ch-6-1', title: '第1话 献舍重生', updateTime: '2019-08-01', pageCount: 42 },
      { id: 'ch-6-2', title: '第2话 蓝氏双璧', updateTime: '2019-08-08', pageCount: 40 },
    ],
  },
  {
    id: 'comic-7',
    title: '镇魂街',
    author: '许辰',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20supernatural%20action%20manhua%20style%20warrior%20with%20ancient%20armor%20and%20glowing%20spirit%20guardian%2C%20dark%20urban%20fantasy%20setting%2C%20dramatic%20lighting%2C%20manga%20cover%20art&width=400&height=560&seq=manga-zhenhunjie&orientation=portrait',
    category: '冒险',
    categorySlug: 'maoxian',
    status: '连载中',
    rating: 9.3,
    description: '镇魂街，此乃吸纳亡灵镇压恶灵之地。每一个镇魂街都有一位镇魂将，负责守护此地的安宁。普通大学生夏铃误入罗刹街，结识了镇魂将曹焱兵。从此，她的人生发生了翻天覆地的变化。',
    updateTime: '2026-08-03',
    views: 1350000,
    tags: ['冒险', '热血', '奇幻', '都市'],
    chapters: [
      { id: 'ch-7-1', title: '第1话 罗刹街', updateTime: '2023-01-08', pageCount: 38 },
      { id: 'ch-7-2', title: '第2话 镇魂将', updateTime: '2023-01-15', pageCount: 42 },
    ],
  },
  {
    id: 'comic-8',
    title: '绝世唐门',
    author: '唐家三少',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20manhua%20style%20young%20boy%20with%20spirit%20ring%20powers%20and%20magical%20glowing%20eyes%2C%20epic%20fantasy%20setting%20with%20magical%20effects%2C%20manga%20cover%20art%20with%20clean%20gradient%20background&width=400&height=560&seq=manga-jueshitangmen&orientation=portrait',
    category: '热血',
    categorySlug: 'rexue',
    status: '连载中',
    rating: 9.4,
    description: '霍雨浩自幼丧母，在公爵府中受尽欺凌。命运的安排让他进入了史莱克学院，在这里，他遇到了改变他一生的人——王冬。两人携手并肩，共同成长，一步步走向巅峰。',
    updateTime: '2026-08-05',
    views: 1680000,
    tags: ['热血', '玄幻', '学院', '成长'],
    chapters: [
      { id: 'ch-8-1', title: '第1话 公爵府的少年', updateTime: '2024-04-01', pageCount: 40 },
      { id: 'ch-8-2', title: '第2话 史莱克学院', updateTime: '2024-04-08', pageCount: 38 },
    ],
  },
  {
    id: 'comic-9',
    title: '非人哉',
    author: '一汪空气',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20manhua%20style%20cute%20mythological%20creatures%20living%20modern%20urban%20life%2C%20colorful%20playful%20characters%2C%20lighthearted%20atmosphere%2C%20funny%20manga%20cover%20art&width=400&height=560&seq=manga-feirenzai&orientation=portrait',
    category: '搞笑',
    categorySlug: 'gaoxiao',
    status: '连载中',
    rating: 9.2,
    description: '九尾狐九月、龙王三太子敖烈、哪吒、观音大士……这些神话传说中的神仙妖怪，在现代都市中过着怎样的生活？《非人哉》以轻松幽默的笔触，展现了神仙妖怪们的爆笑日常。',
    updateTime: '2026-08-04',
    views: 1120000,
    tags: ['搞笑', '日常', '神话', '都市'],
    chapters: [
      { id: 'ch-9-1', title: '第1话 九月的日常', updateTime: '2022-06-10', pageCount: 24 },
      { id: 'ch-9-2', title: '第2话 敖烈的烦恼', updateTime: '2022-06-17', pageCount: 22 },
    ],
  },
  {
    id: 'comic-10',
    title: '秦时明月',
    author: '温世仁',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20martial%20arts%20manhua%20style%20swordsman%20in%20ancient%20Qin%20dynasty%20setting%2C%20epic%20landscape%20with%20Great%20Wall%2C%20traditional%20Chinese%20ink%20painting%20style%2C%20manga%20cover%20art&width=400&height=560&seq=manga-qinshimingyue&orientation=portrait',
    category: '古风',
    categorySlug: 'gufeng',
    status: '连载中',
    rating: 9.5,
    description: '秦始皇统一六国后，天下初定，但暗流涌动。少年荆天明在逃亡中结识了剑圣盖聂和楚国的少主项少羽。三人踏上了一条充满危险与挑战的旅途，开启了一段波澜壮阔的江湖传奇。',
    updateTime: '2026-08-03',
    views: 1450000,
    tags: ['古风', '历史', '武侠', '冒险'],
    chapters: [
      { id: 'ch-10-1', title: '第1话 天下第一剑', updateTime: '2023-09-01', pageCount: 40 },
      { id: 'ch-10-2', title: '第2话 残月谷', updateTime: '2023-09-08', pageCount: 38 },
    ],
  },
  {
    id: 'comic-11',
    title: '大理寺日志',
    author: 'RC',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20manhua%20style%20detective%20cat%20man%20in%20ancient%20Tang%20dynasty%20official%20uniform%2C%20mysterious%20palace%20setting%2C%20dramatic%20shadows%2C%20manga%20cover%20art&width=400&height=560&seq=manga-dalisirizhi&orientation=portrait',
    category: '悬疑',
    categorySlug: 'xuanyi',
    status: '连载中',
    rating: 9.4,
    description: '唐朝武周时期，大理寺少卿李饼是一只白猫，他与属下陈拾等人一起，侦破各种离奇案件。在大理寺的日常中，既有紧张刺激的探案过程，也有轻松诙谐的日常趣事。',
    updateTime: '2026-08-02',
    views: 980000,
    tags: ['悬疑', '古风', '探案', '历史'],
    chapters: [
      { id: 'ch-11-1', title: '第1话 大理寺少卿', updateTime: '2023-11-10', pageCount: 36 },
      { id: 'ch-11-2', title: '第2话 第一案', updateTime: '2023-11-17', pageCount: 34 },
    ],
  },
  {
    id: 'comic-12',
    title: '星骸骑士',
    author: '黑天视觉',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20mecha%20manhua%20style%20futuristic%20knight%20pilot%20in%20space%20with%20giant%20robot%2C%20epic%20space%20battle%20background%2C%20manga%20cover%20art%20with%20clean%20dark%20space%20theme&width=400&height=560&seq=manga-xinghaiqishi&orientation=portrait',
    category: '科幻',
    categorySlug: 'kehuan',
    status: '连载中',
    rating: 9.1,
    description: '在遥远的未来，人类已经进入了星际时代。少年陈末在一次意外中获得了远古星骸骑士的传承，从此踏上了拯救银河系的征途。面对强大的外星敌人，他必须不断成长，成为真正的星骸骑士。',
    updateTime: '2026-08-05',
    views: 760000,
    tags: ['科幻', '机甲', '冒险', '热血'],
    chapters: [
      { id: 'ch-12-1', title: '第1话 星骸觉醒', updateTime: '2024-07-01', pageCount: 40 },
      { id: 'ch-12-2', title: '第2话 初次战斗', updateTime: '2024-07-08', pageCount: 38 },
    ],
  },
];

export const getComicsByCategory = (slug: string): Comic[] => {
  return comics.filter((c) => c.categorySlug === slug);
};

export const getComicById = (id: string): Comic | undefined => {
  return comics.find((c) => c.id === id);
};

export const getHotComics = (limit: number = 6): Comic[] => {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
};

export const getLatestComics = (limit: number = 8): Comic[] => {
  return [...comics].sort((a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime()).slice(0, limit);
};

export const getTopRatedComics = (limit: number = 10): Comic[] => {
  return [...comics].sort((a, b) => b.rating - a.rating).slice(0, limit);
};

export const getRelatedComics = (comicId: string, limit: number = 4): Comic[] => {
  const comic = getComicById(comicId);
  if (!comic) return [];
  return comics.filter((c) => c.id !== comicId && c.categorySlug === comic.categorySlug).slice(0, limit);
};